export default "__VITE_ASSET__B4FP_ila__"